import { call, put, takeLatest } from 'redux-saga/effects'
import { START_SORT_BRAND_LINES } from '../types'
import {
  successSortBrandLines,
  errorSortBrandLines
} from '../actions/lines'
import { apiCall } from '../config/axios'

function* sortBrandLinesSaga(action) {
  try {
    console.log('Saga activa - Payload:', action.payload)

    yield call(apiCall, 'patch', '/brand-lines/sort', action.payload)

    yield put(successSortBrandLines())
  } catch (error) {
    console.error('Error en saga sortBrandLines:', error)
    yield put(errorSortBrandLines(error.message || 'Error inesperado'))
  }
}

export function* watchSortBrandLines() {
  yield takeLatest(START_SORT_BRAND_LINES, sortBrandLinesSaga)
}
